import {
  Box,
  Divider,
  List,
  Typography,
  useColorScheme,
  ListItem as GenericListItem,
  Collapse
} from "@mui/material";
import {
  ContentCopyRounded as CopyIcon,
  DarkModeRounded as DarkModeIcon,
  LightModeRounded as LightModeIcon
} from "@mui/icons-material";
import FeedbackIcon from "@mui-symbols-material/w400/ForumRounded";

import { useStore, observer } from "../../../service/mobx";
import { AnonymousIcon } from "../../Icon/Anonymous";
import { DiscordIcon } from "../../Icon/Discord";
import { ListItem } from "../../List/ListItem";
import { dialogFeedback } from "../../Dialog/dialogs/appWide/Feedback";
import Skeleton from "../../Skeleton";

function AccountMenu() {
  // const { snackbar, user } = useStore();

  return <Component />;
}
const Component = observer(function Component() {
  const { dialog, snackbar, menu, user } = useStore();
  const line1Sx = { textTransform: "unset" };

  return (
    <List
      disablePadding
      dense
      sx={{
        p: 0,
        "& svg": {
          opacity: 0.5
        },
        "& .MuiButtonBase-root:hover svg": {
          opacity: 1
        }
      }}
    >
      <Profile line1Sx={line1Sx} />
      <ListItem
        line1Sx={line1Sx}
        line1="API key"
        line2={user.isAnonymous ? "Login to reveal" : undefined}
        trailing={{ Icon: CopyIcon }}
        href={user.isAnonymous ? "/auth" : undefined}
        onClick={() => {
          menu.set.open(false);

          if (user.isAnonymous) {
            snackbar.notify({ text: "Please login" });
          } else {
            snackbar.notify({ text: "Copied" });
            navigator.clipboard.writeText(user.profile.key);
          }
        }}
      />
      <Divider />
      <ChangeTheme line1Sx={line1Sx} />
      <ListItem
        line1Sx={line1Sx}
        line1="Contact us"
        line2="Send feedback or get help"
        trailing={{ Icon: FeedbackIcon }}
        onClick={() => dialog.configure(dialogFeedback)}
      />
      <ListItem
        line1Sx={line1Sx}
        target="_blank"
        href="https://discord.gg/ZydhEJTd3R"
        line1="Join our community"
        line2="Help us build Bytez"
        trailing={{
          Icon: () => <DiscordIcon sx={{ color: "var(--tertiary-color)" }} />
        }}
      />
      <Divider />
      <ListItem
        line1Sx={line1Sx}
        line1={`Log ${user.isAnonymous ? "in" : "out"}`}
        href={user.isAnonymous ? "/auth" : undefined}
        onClick={user.isAnonymous ? () => menu.set.open(false) : user.sign.out}
      />
    </List>
  );
});

export default observer(AccountMenu);

const Profile = observer(function Profile({ line1Sx }) {
  const { user } = useStore();

  return (
    <>
      <ListItem
        line1Sx={line1Sx}
        disableRipple
        line1={user.isAnonymous ? "Anonymous" : user.session.displayName}
        line2={
          user.loaded ? (
            user.isAnonymous ? (
              "Limited tier"
            ) : user.premium ? (
              "Premium"
            ) : (
              "Free tier"
            )
          ) : (
            <Skeleton width={64} height={20} />
          )
        }
        leading={{ Icon: AnonymousIcon, img: user.photo }}
        sx={{
          "&:hover": {
            cursor: "default",
            bgcolor: "unset"
          },
          "& svg": {
            opacity: 1,
            color: "var(--surface-on-variant)"
          }
        }}
      />

      <Collapse in={user.loaded && user.premium !== true}>
        <GenericListItem>
          <Box
            p={1}
            width="100%"
            borderRadius="var(--shape-xs-round)"
            bgcolor="var(--primary-container)"
          >
            <Typography
              variant="titleSm"
              fontWeight={600}
              component="a"
              href={user.isAnonymous ? "/auth" : "/api/pricing"}
              color="var(--primary-on-container)"
              sx={{
                cursor: "pointer",
                textWrap: "balance",
                textDecoration: "none"
              }}
            >
              {user.isAnonymous
                ? "Join the community"
                : "Upgrade to Pay-As-You-Go"}
            </Typography>
            <Typography
              mt={1}
              component="p"
              color="var(--primary-on-container)"
              variant="bodySm"
              sx={{ textWrap: "balance" }}
            >
              {user.isAnonymous
                ? "Access thousands of models for free"
                : "Access bigger models and better rate limits"}
            </Typography>
          </Box>
        </GenericListItem>
      </Collapse>
    </>
  );
});

function ChangeTheme() {
  const { mode, setMode, systemMode } = useColorScheme();
  const dark = systemMode === "dark" || mode === "dark";
  const Icon = dark ? DarkModeIcon : LightModeIcon;

  return (
    <ListItem
      line1={`${dark ? "Dark" : "Light"} theme`}
      onClick={() => setMode(dark ? "light" : "dark")}
      line1Sx={{ textTransform: "unset" }}
      trailing={{ Icon: () => <Icon sx={{ color: "var(--primary-color)" }} /> }}
    />
  );
}
